<template>
    <!-- 空手道 -->
  <div class="box-css">
    <div class="type-css">
      <div>
        <span style="font-size:16px;">
          <b>获胜方式统计</b>&ensp;&ensp;|&ensp;&ensp;
          共计胜场{{ detail.winNum }}场次
        </span>
      </div>
      <div id="main" style="height: 300px;"></div>
      <div class="type-font-box">
        <div>KACHI：比分胜</div>
        <div>HACHI_KACHI：优势胜</div>
        <div>SENSHU：先取胜</div>
        <div>HANTEI：判定胜</div>
        <div>HANSOKU：犯规胜</div>
        <div>KIKEN：弃权胜</div>
        <div>SHIKKAKU：失格胜</div>
        <div>HIKIWAKE_KIKEN：双方弃权</div>
        <div>HIKIWAKE_SHIKKAKU：双方失格</div>
        <div>HIKIWAKE：平局</div>
      </div>
    </div>
    <div class="radar-css">
      <div>
        <span class="radar-span">
          <b>攻防对比</b>（近10场）
        </span>
      </div>
      <div id="main2" style="height: 300px;"></div>
      <span class="badge-a">
        <a-badge status="error" :text="attackDefense.defense.first + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.first + ''" />
      </span>
      <span class="badge-b">
        <a-badge status="error" :text="attackDefense.defense.ippon + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.ippon + ''" />
      </span>
      <span class="badge-c">
        <a-badge status="error" :text="attackDefense.defense.wazaari + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.wazaari + ''" />
      </span>
      <span class="badge-d">
        <a-badge status="error" :text="attackDefense.defense.yoku + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.yoku + ''" />
      </span>
    </div>
    <div class="poomsae-css">
      <div style="margin-top:30px;">
        <span style="font-size:16px;">
          <b>型分析</b>（近10场）
        </span>
      </div>
      <div v-if="data.poomsae !== null">
        <div class="poomsae-circle">
          <a-progress type="circle" style="margin-top:50px;margin-right:60px;" :percent="(data.xin.motion / 6) * 100"  :width="230" :strokeWidth="13" strokeColor="#244e8f">
            <template #format="percent">
              <span style="display:none;">{{ percent }}</span>
              <font style="font-size:28px;"><b>{{ data.xin.motion }} / 6</b> </font><br/><br/> <font style="font-size:18px;color:gray;">运动能力</font>
            </template>
          </a-progress>
          <a-progress type="circle" :percent="(data.xin.skill / 4) * 100"  :width="230" :strokeWidth="13" strokeColor="#04b4e5">
            <template #format="percent">
              <span style="display:none;">{{ percent }}</span>
              <font style="font-size:28px;"><b>{{ data.xin.skill }} / 4</b> </font><br/> <br/> <font style="font-size:18px;color:gray;">技术能力</font>
            </template>
          </a-progress>
        </div>
        <div class="time-list">
          <div class="time-item" style="font-weight:bold;">
            <div class="time-item-li">比赛时间</div>
            <div class="time-item-li">运动能力</div>
            <div class="time-item-li">技术能力</div>
            <div class="time-item-li">总分</div>
          </div>
          <div class="time-item" v-for="(item,index) in data.xin.details" :key="index" :style="{background: index % 2 === 0 ? 'white' : 'rgb(241, 241, 241)'}">
            <div class="time-item-li">{{ matchFun.formatDate(item.time) }}</div>
            <div class="time-item-li">{{ item.motion }}</div>
            <div class="time-item-li">{{ item.skill }}</div>
            <div class="time-item-li">{{ item.score }}</div>
          </div>
        </div>
      </div>
      <a-empty v-else/>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import matchFun from '@comm/utils/matchFun.js'
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      rank: this.$route.query.rank,
      matchFun,
      detail: {},
      data: {
        xin: {
          motion: 0,
          skill: 0,
          details: []
        },
        power: {
          maxPower: 0,
          totalPower: 0,
          details: []
        },
        speed: {
          best: 0,
          fast: 0,
          details: []
        }
      },
      attackDefense: {
        defense: {
          first: 0,
          ippon: 0,
          wazaari: 0,
          yoku: 0,
        },
        attack: {
          first: 0,
          ippon: 0,
          wazaari: 0,
          yoku: 0,
        }
      }
    }
  },
  created () {
    this.detail = JSON.parse(decodeURI(this.$route.query.detail))
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.playerTechnical({cardId: this.detail.cardId, programId: this.programId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.attackDefense = res.data.attackDefense
          this.drawData(res.data.winType)
          this.radarData(res.data.attackDefense)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    drawData (data) {
      let arr = []
      for (let key in data) {
        arr.push({
          value: data[key],
          name: key.toUpperCase() + '：' + data[key]
        })
      }
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#04b4e5', '#049b18', '#224f8a', '#006dd6', '#72c707', '#ffcf01', '#ff8a00', '#ff7200', '#ff4f01'],
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 30,
          top: 20,
          bottom: 20,
          itemHeight: 16
        },
        series: [
          {
            name: '数据',
            type: 'pie',
            radius: ['50%', '70%'],
            label: {
              show: false,
              position: 'center'
            },
            left: 0,
            top: 0,
            data: arr
          }
        ]
      }

      option && myChart.setOption(option)
    },
    radarData (data) {
      var chartDom = document.getElementById('main2')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'axis'
        },
        color: ['#04b4e5', '#ff4f01'],
        legend: {
          left: 'center',
          data: [
            '得分数据',
            '失分数据'
          ]
        },
        radar: [
          {},
          {
            indicator: [
              { text: '有技' },
              { text: '一本' },
              { text: '有效' },
              { text: '先取' },
            ],
            radius: 80,
            center: ['50%', '50%']
          }
        ],
        series: [
          {
            type: 'radar',
            radarIndex: 1,
            areaStyle: {},
            data: [
              {
                value: [data.attack.first, data.attack.ippon, data.attack.wazaari, data.attack.yoku],
                name: '得分数据'
              },
              {
                value: [data.defense.first, data.defense.ippon, data.defense.wazaari, data.defense.yoku],
                name: '失分数据'
              }
            ]
          }
        ]
      }

      option && myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.box-css{
  width: 1200px;
  margin: 20px auto;
  overflow: hidden;
}
.type-css{
  width: 700px;
  float: left;
  height: 320px;
  border-right: 1px solid rgb(231, 231, 231);
  position: relative;
}
.radar-css{
  width: 500px;
  float: left;
  height: 320px;
  position: relative;
}
.poomsae-css{
  width: 1200px;
  float: left;
  height: 390px;
  position: relative;
  border-top: 5px solid rgb(238, 236, 236);
  border-bottom: 5px solid rgb(238, 236, 236);
  margin-top: 30px;
}
.time-list{
  width:600px;max-height: 300px;overflow-y: auto;float:left;
}
.time-item{
  width:100%;height:45px;line-height:45px;background:rgb(241, 241, 241);
}
.time-item-li{
  width:25%;height:45px;float:left;text-align: center;
}
.power-css{
  width: 1200px;
  float: left;
  height: 410px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
}
.time-line{
  position: absolute;top: 23px;left: 17px;z-index: 99;color:white;
}
.type-font-box{
  position: absolute;left: 0px;top: 40px;line-height:26px;color:gray;
}
.radar-span{
  font-size:16px;margin-left:20px;
}
.badge-a{
  position: absolute;top: 60px;left: 270px;line-height:15px;
}
.badge-b{
  position: absolute;top: 180px;left: 140px;line-height:15px;
}
.badge-c{
  position: absolute;top: 180px;left: 355px;line-height:15px;
}
.badge-d{
  position: absolute;top: 280px;left:240px;line-height:15px;
}
// .badge-e{
//   position: absolute;top: 180px;left: 105px;line-height:15px;
// }
.poomsae-circle{
  width:600px;height:300px;float:left;
}
.power-head{
  width:50%;float:left;padding-right:5%;border-right: 1px solid #e7e7e7;height:410px;
}
.power-gat{
  width:50%;height:70px;text-align: center;line-height: 30px;font-size: 16px;color:#ccc;float:left;
}
.speed-head{
  width:50%;height:70px;text-align: center;line-height: 30px;font-size: 16px;color:#ccc;float:left;
}
.fast-box{
  width:45%;float:left;padding-left:20px;
}
.speed-head b{
  font-size:30px;color:gray;
}
.power-gat b{
  font-size:30px;color:gray;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/module/SkillKarate.vue